import { Button, Modal } from "react-bootstrap";
import { InputDateTime } from "../../../components/input";
import { useEffect, useState } from "react";
import { CreateNotification } from "../../../components/notifier";

type editRepiarTools = {
  onClose: () => void;
  isOpen: boolean;
  onDateChange: (date: Date) => void;
  value: Date | undefined;
  isShowTime: boolean;
};

const EditRepairToolsModal = (props: editRepiarTools) => {
  const { onClose, isOpen, onDateChange, value, isShowTime } = props;
  const [inputDateTime, setInputDateTime] = useState(new Date());

  const onDateTimeChange = (date: any) => {
    setInputDateTime(date);
  };

  const confirmDateChange = async () => {
    if (inputDateTime) {
      onDateChange(inputDateTime);
      onClose();
    } else {
      CreateNotification({
        title: "Thông báo",
        body: `Vui lòng chọn ngày tạo !`,
        icon: "/icons/warning.png",
      });
    }
  };

  useEffect(() => {
    if (value) setInputDateTime(new Date(value));
  }, [value]);

  return (
    <Modal show={isOpen} onHide={onClose} size="sm" centered className="add-folder-modal">
      <Modal.Header closeButton>
        <Modal.Title>Chỉnh sửa ngày</Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-4 px-4">
        <InputDateTime
          name="Ngày giờ"
          onChange={onDateTimeChange}
          onTouched={() => {}}
          value={inputDateTime}
          isShowTime={isShowTime}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} variant="secondary">
          Hủy
        </Button>
        <Button onClick={confirmDateChange} variant="info">
          Xác nhận
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditRepairToolsModal;
